import { mapGetters } from 'vuex';
import LessonsPricesForm from '@/components/modals/LessonsPricesForm.vue';
import MessageForm from '@/components/modals/MessageForm.vue';
import ImageUploader from '@/components/fileUpload/ImageUploader.vue';

export default {
  computed: {
    ...mapGetters({
      choosenTimezone: 'timezone/choosenTimezone',
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
      dashboardPath: 'auth/dashboardPath',
    }),
  },

  methods: {
    capitalLetter(value) {
      const capitalName = value.charAt(0).toUpperCase() + value.slice(1);
      return capitalName;
    },

    goToDashboard() {
      this.$router.push({ path: this.dashboardPath }).catch(() => {});
    },

    openModalPrices() {
      if (this.user.teacher !== null) {
        this.$modal.show(LessonsPricesForm, {},
          { clickToClose: false, adaptive: true });
      }
      // else : è ancora da fare
      this.$emit('close');
    },

    getTeacherRate(rate) {
      const colorHarpArray = {
        grayHarps: Math.floor(5 - rate),
        halfColorHarps: 0,
        colorfulHarps: Math.floor(rate),
      };

      if (rate % 2 !== Math.round(rate % 2)) {
        colorHarpArray.halfColorHarps = 1;
      }
      return colorHarpArray;
    },

    async loadDashboard(user, isTeacher) {
      if (user.id === this.user.id) {
        this.goToDashboard();
        return;
      }
      if (isTeacher) {
        this.$router.replace({ path: `/teachers/${user.slug}` });
        return;
      }
      this.$router.replace({ path: `/students/${user.slug}` });
    },

    contact(fromUser, toUser) {
      this.$modal.show(
        MessageForm, { fromUser, toUser },
        { adaptive: true, draggable: true },
      );
    },

    openMasterclassView(event) {
      const id = event.id.split('_')[1];
      this.$router.push(`/dashboard/masterclass/${id}`);
    },

    openImageModal(id) {
      this.$modal.show(ImageUploader, {
        id,
      });
    },

  },
};
